import store from '../redux/page/store'
import {get} from 'lodash'
export default function initializeAccessEnabler() {
	const hasSoftwareStatement = get(window.settings, 'tveSettings.software_statement')
	if(hasSoftwareStatement){
		accessEnabler()
	}
}

function load(url) {
	return new Promise(function(resolve, reject) {
		var script = document.createElement('script');
		script.type = 'text/javascript';
		script.async = true;
		script.src = url;
		script.onload = resolve;
		script.onerror = reject;
		document.body.appendChild(script);
	})
}

function accessEnablerDidLoad(){
    var softwareStatement = window.settings.tveSettings.software_statement;
    window.AE = new window.AccessEnabler.AccessEnabler(softwareStatement);
}

function accessEnabler(){
	store.dispatch({
        type: 'ADOBE_STATUS',
        payload: true
      })
	load('//entitlement.auth.adobe.com/entitlement/v4/AccessEnabler.js').then(()=>{
		accessEnablerDidLoad()
	})
}

